
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Play, Square } from 'lucide-react';
import type { TimeRecord } from '@/types';

interface ActiveTimeRecordProps {
  activeTimeRecord: TimeRecord | null;
  onClockOut: () => void;
  locationLoading: boolean;
  hasLocation: boolean;
}

const ActiveTimeRecord: React.FC<ActiveTimeRecordProps> = ({ 
  activeTimeRecord, 
  onClockOut, 
  locationLoading, 
  hasLocation 
}) => {
  if (!activeTimeRecord) return null;

  const formatDuration = (minutes: number) => {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${hours}h ${mins}m`;
  };

  const currentDuration = Math.floor(
    (Date.now() - new Date(activeTimeRecord.clock_in_time).getTime()) / 60000
  );

  return (
    <Card className="mb-6 border-green-200 bg-green-50">
      <CardHeader>
        <CardTitle className="flex items-center text-green-800">
          <Play className="h-5 w-5 mr-2" />
          Currently Clocked In
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex justify-between items-center">
          <div>
            <p className="text-sm text-green-700">
              Started: {new Date(activeTimeRecord.clock_in_time).toLocaleTimeString()}
            </p>
            <p className="text-xs text-green-600">
              Duration: {formatDuration(currentDuration)}
            </p>
          </div>
          <Button 
            onClick={onClockOut}
            disabled={locationLoading || !hasLocation}
            className="bg-red-600 hover:bg-red-700"
          >
            <Square className="h-4 w-4 mr-2" />
            {locationLoading ? 'Getting Location...' : 'Clock Out'}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default ActiveTimeRecord;
